module.exports = __webpack_public_path__ + "img/enabled_selected.2494a860.svg";